import React, { useState, useMemo, useEffect } from "react";
import { Link } from "react-router-dom";
import Icon from "components/AppIcon";
import Header from "../../layout/Header";
import FilterToolbar from "./components/FilterToolbar";
import Pagination from "./components/Pagination";
import { useDispatch, useSelector } from "react-redux";

import { toast } from "react-toastify";
import TrainersTable from "./components/ContactUserTable";
import {
  deleteTrainerService,
  getTrainersService,
} from "redux/services/trainers_service";
import { useLanguage } from "../../LanguageContext";
import { getAllContactUSerService } from "redux/services/general_service";

const translations = {
  en: {
    pageTitle: "Contact Us ",
    addNewTrainer: "Add New Trainer",
    totalTrainers: "Total trainers",
    successMessage: "Success",
  },
  ar: {
    pageTitle: "تواصل معنا ",
    addNewTrainer: "إضافة مدرب جديد",
    totalTrainers: "إجمالي المدربين",
    successMessage: "نجاح",
  },
};

const ContactManagment = () => {
  const dispatch = useDispatch();
  const { language } = useLanguage();

  const permissions = JSON.parse(localStorage.getItem("permissions"));

  const viewContactExists = permissions.some(
    (permission) => permission.name === "view_contact_us_form"
  );

  const [selectedClients, setSelectedClients] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    search: "",
    status: "All",
    dateRange: { start: "", end: "" },
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const { contactUserList, metaContactUser } = useSelector(
    (state) => state.general
  );

  // Mock client data
  const mockClients = [
    // ... (mock client data remains unchanged)
  ];

  const itemsPerPage = 6;

  // Filter clients based on search and status
  const filteredClients = useMemo(() => {
    return mockClients.filter((client) => {
      const matchesSearch =
        client.name.toLowerCase().includes(filters.search.toLowerCase()) ||
        client.phone.includes(filters.search) ||
        client.email.toLowerCase().includes(filters.search.toLowerCase());

      const matchesStatus =
        filters.status === "All" ||
        client.subscriptionStatus === filters.status;

      let matchesDateRange = true;
      if (filters.dateRange.start && filters.dateRange.end) {
        const clientStartDate = new Date(client.startDate);
        const filterStartDate = new Date(filters.dateRange.start);
        const filterEndDate = new Date(filters.dateRange.end);
        matchesDateRange =
          clientStartDate >= filterStartDate &&
          clientStartDate <= filterEndDate;
      }

      return matchesSearch && matchesStatus && matchesDateRange;
    });
  }, [filters]);

  // Paginate filtered clients
  const paginatedClients = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return filteredClients.slice(startIndex, startIndex + itemsPerPage);
  }, [filteredClients, currentPage]);

  const totalPages = Math.ceil(filteredClients.length / itemsPerPage);

  const handlePageChange = (page) => {
    console.log(`Changing to page: ${page}`);
    setCurrentPage(page);
    dispatch(getTrainersService({ page: page }));
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedClients(paginatedClients.map((client) => client.id));
    } else {
      setSelectedClients([]);
    }
  };

  const handleSelectClient = (clientId, checked) => {
    if (checked) {
      setSelectedClients((prev) => [...prev, clientId]);
    } else {
      setSelectedClients((prev) => prev.filter((id) => id !== clientId));
    }
  };

  const handleDeleteClient = (clientId) => {
    dispatch(deleteTrainerService(clientId)).then((response) => {
      if (response.payload?.status === 200) {
        toast.success(
          language === "ar" ? "تم الحذف بنجاح" : "Deleted successfully"
        );

        dispatch(getTrainersService({ page: 1 }));
      }
    });
  };

  const handleRenewSubscription = (clientId) => {
    console.log("Renewing subscription for client:", clientId);
  };

  const handleBulkAction = (action) => {
    console.log(`Performing ${action} on clients:`, selectedClients);
    if (action === "delete") {
      setSelectedClients([]);
    }
  };

  useEffect(() => {
    dispatch(getAllContactUSerService({ page: 1 }));
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="p-6">
        <div className="mb-6">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mt-12">
            <div>
              <h1 className="text-2xl lg:text-3xl font-bold text-gray-900">
                {translations[language].pageTitle}
              </h1>
            </div>
         
          </div>
        </div>

        {viewContactExists && (
          <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
            <TrainersTable
              clients={contactUserList}
              selectedClients={selectedClients}
              onSelectAll={handleSelectAll}
              onSelectClient={handleSelectClient}
              onDeleteClient={handleDeleteClient}
              onRenewSubscription={handleRenewSubscription}
              allSelected={
                selectedClients.length === paginatedClients.length &&
                paginatedClients.length > 0
              }
            />

            {metaContactUser?.total > 9 && (
              <Pagination
                currentPage={metaContactUser?.current_page}
                totalPages={metaContactUser?.last_page}
                onPageChange={handlePageChange}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactManagment;
